import React, { useState, useEffect } from 'react';
import { FaEdit, FaTrash, FaPlus, FaSearch, FaSave, FaTimes } from 'react-icons/fa';
import '../Nucleos/Nucleos.css';

import API_BASE_URL from '../../../../config/api';

const TiposLicenca = () => {
  const [tiposLicenca, setTiposLicenca] = useState([]);
  const [orgaos, setOrgaos] = useState([]);
  const [textosPadrao, setTextosPadrao] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({
    tipo_licenca: '',
    aplicavel: '',
    tipo: '',
    sigla: '',
    prazo: '',
    id_orgao: '',
    id_txpadrao: '',
    ativo: true
  });

  useEffect(() => {
    fetchTipos();
    fetchDependencies();
  }, []);

  const fetchTipos = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/tipos-licenca`);
      if (!response.ok) {
        throw new Error('Erro ao buscar tipos de licença');
      }
      const data = await response.json();
      setTiposLicenca(data);
    } catch (error) {
      console.error('Erro ao carregar tipos de licença:', error);
    }
  };

  const fetchDependencies = async () => {
    try {
      const [resOrgaos, resTextos] = await Promise.all([
        fetch(`${API_BASE_URL}/orgaos-referencia`),
        fetch(`${API_BASE_URL}/texto-padrao`)
      ]);

      if (resOrgaos.ok) {
        const dataOrgaos = await resOrgaos.json();
        setOrgaos(dataOrgaos);
      }
      
      if (resTextos.ok) {
        const dataTextos = await resTextos.json();
        setTextosPadrao(dataTextos);
      }
    } catch (error) {
      console.error('Erro ao carregar dependências:', error);
    }
  };

  const filteredTiposLicenca = tiposLicenca.filter((tipo) =>
    tipo.tipo_licenca.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      tipo_licenca: formData.tipo_licenca,
      aplicavel: formData.aplicavel,
      tipo: formData.tipo,
      sigla: formData.sigla,
      prazo: formData.prazo,
      id_orgao: formData.id_orgao,
      id_txpadrao: formData.id_txpadrao,
      ativo: formData.ativo
    };

    try {
      if (editingId) {
        const response = await fetch(`${API_BASE_URL}/tipos-licenca/${editingId}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao atualizar tipo de licença');
        }

        const updated = await response.json();
        setTiposLicenca(
          tiposLicenca.map((tipo) => (tipo.id === editingId ? updated : tipo))
        );
      } else {
        const response = await fetch(`${API_BASE_URL}/tipos-licenca`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error('Erro ao criar tipo de licença');
        }

        const created = await response.json();
        setTiposLicenca([...tiposLicenca, created]);
      }

      resetForm();
    } catch (error) {
      console.error('Erro ao salvar tipo de licença:', error);
    }
  };

  const handleEdit = (tipoLicenca) => {
    setFormData({
      tipo_licenca: tipoLicenca.tipo_licenca,
      aplicavel: tipoLicenca.aplicavel || '',
      tipo: tipoLicenca.tipo || '',
      sigla: tipoLicenca.sigla || '',
      prazo: tipoLicenca.prazo || '',
      id_orgao: tipoLicenca.id_orgao || '',
      id_txpadrao: tipoLicenca.id_txpadrao || '',
      ativo: tipoLicenca.ativo
    });
    setEditingId(tipoLicenca.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Tem certeza que deseja excluir este tipo de licença?')) {
      return;
    }

    try {
      const response = await fetch(`${API_BASE_URL}/tipos-licenca/${id}`, {
        method: 'DELETE'
      });

      if (!response.ok && response.status !== 204) {
        throw new Error('Erro ao excluir tipo de licença');
      }

      setTiposLicenca(tiposLicenca.filter((tipo) => tipo.id !== id));
    } catch (error) {
      console.error('Erro ao excluir tipo de licença:', error);
    }
  };

  const resetForm = () => {
    setFormData({
      tipo_licenca: '',
      aplicavel: '',
      tipo: '',
      sigla: '',
      prazo: '',
      id_orgao: '',
      id_txpadrao: '',
      ativo: true
    });
    setEditingId(null);
    setShowForm(false);
  };

  const handleToggleStatus = async (id) => {
    const tipo = tiposLicenca.find((t) => t.id === id);
    if (!tipo) return;

    const updatedTipo = {
      ...tipo,
      ativo: !tipo.ativo
    };

    try {
      const response = await fetch(`${API_BASE_URL}/tipos-licenca/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          tipo_licenca: updatedTipo.tipo_licenca,
          aplicavel: updatedTipo.aplicavel,
          tipo: updatedTipo.tipo,
          sigla: updatedTipo.sigla,
          prazo: updatedTipo.prazo,
          id_orgao: updatedTipo.id_orgao,
          id_txpadrao: updatedTipo.id_txpadrao,
          ativo: updatedTipo.ativo
        })
      });

      if (!response.ok) {
        throw new Error('Erro ao atualizar status do tipo de licença');
      }

      const saved = await response.json();
      setTiposLicenca(
        tiposLicenca.map((t) => (t.id === id ? saved : t))
      );
    } catch (error) {
      console.error('Erro ao atualizar status do tipo de licença:', error);
    }
  };

  return (
    <div className="nucleos-container">
      <div className="tabela-header">
        <div className="header-content">
          <h1>Tipos de Licença</h1>
        </div>
      </div>

      {showForm ? (
        <div className="form-container inline-form">
          <div className="form-header">
            <h2>{editingId ? 'Editar Tipo de Licença' : 'Novo Tipo de Licença'}</h2>
          </div>
          
          <form onSubmit={handleSubmit} className="form-content">
            <div className="form-group">
              <label htmlFor="tipo_licenca">Tipo de Licença *</label>
              <input
                type="text"
                id="tipo_licenca"
                value={formData.tipo_licenca}
                onChange={(e) => setFormData({ ...formData, tipo_licenca: e.target.value })}
                required
                maxLength={100}
                placeholder="Digite o tipo de licença"
              />
            </div>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="aplicavel">Aplicável</label>
                <input
                  type="text"
                  id="aplicavel"
                  value={formData.aplicavel}
                  onChange={(e) => setFormData({ ...formData, aplicavel: e.target.value })}
                  maxLength={100}
                  placeholder="Ex: PJ"
                />
              </div>

              <div className="form-group col-md-6">
                <label htmlFor="tipo">Tipo</label>
                <input
                  type="text"
                  id="tipo"
                  value={formData.tipo}
                  onChange={(e) => setFormData({ ...formData, tipo: e.target.value })}
                  maxLength={100}
                  placeholder="Ex: Licença Ambiental"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group col-md-6">
                <label htmlFor="sigla">Sigla</label>
                <input
                  type="text"
                  id="sigla"
                  value={formData.sigla}
                  onChange={(e) => setFormData({ ...formData, sigla: e.target.value })}
                  maxLength={20}
                  placeholder="Ex: LP"
                />
              </div>

              <div className="form-group col-md-6">
                <label htmlFor="prazo">Prazo (anos)</label>
                <input
                  type="number"
                  id="prazo"
                  value={formData.prazo}
                  onChange={(e) => setFormData({ ...formData, prazo: e.target.value })}
                  placeholder="Ex: 5"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="id_orgao">Referência (Órgão)</label>
              <select
                id="id_orgao"
                value={formData.id_orgao}
                onChange={(e) => setFormData({ ...formData, id_orgao: e.target.value })}
              >
                <option value="">Selecione um órgão de referência</option>
                {orgaos.map((orgao) => (
                  <option key={orgao.id_orgao_referencia} value={orgao.id_orgao_referencia}>
                    {orgao.nome_orgao_referencia}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="id_txpadrao">Texto Padrão</label>
              <select
                id="id_txpadrao"
                value={formData.id_txpadrao}
                onChange={(e) => setFormData({ ...formData, id_txpadrao: e.target.value })}
              >
                <option value="">Selecione um texto padrão</option>
                {textosPadrao.map((texto) => (
                  <option key={texto.id} value={texto.id}>
                    {texto.titulo}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  id="ativo"
                  checked={formData.ativo}
                  onChange={(e) => setFormData({ ...formData, ativo: e.target.checked })}
                />
                <label htmlFor="ativo">Ativo</label>
              </div>
            </div>

            <div className="form-actions">
              <button type="button" className="btn-secondary" onClick={resetForm}>
                <FaTimes /> Cancelar
              </button>
              <button type="submit" className="btn-primary">
                <FaSave /> {editingId ? 'Atualizar' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      ) : (
        <div className="table-container">
            <div className="table-controls">
            <div className="search-container">
              <FaSearch />
              <input
                type="text"
                placeholder="Pesquisar tipos de licença..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-info">
              <span>{filteredTiposLicenca.length} registro(s) encontrado(s)</span>
            </div>
            <button 
              className="btn-primary"
              onClick={() => setShowForm(true)}
            >
              <FaPlus /> Novo Tipo de Licença
            </button>
          </div>

          <div className="table-wrapper">
            <table className="data-table nucleos-table">
              <thead>
                <tr>
                  <th className="col-id">ID</th>
                  <th className="col-nome">Tipo de Licença</th>
                  <th className="col-sigla">Aplicável</th>
                  <th className="col-nome">Tipo</th>
                  <th className="col-sigla">Sigla</th>
                  <th className="col-prazo">Prazo (anos)</th>
                  <th className="col-nome">Referência</th>
                  <th className="col-nome">Texto Padrão</th>
                  <th className="col-status">Status</th>
                  <th className="col-acoes">Ações</th>
                </tr>
              </thead>
              <tbody>
                {filteredTiposLicenca.map(tipo => (
                  <tr key={tipo.id}>
                    <td className="col-id">{tipo.id}</td>
                    <td className="col-nome">{tipo.tipo_licenca}</td>
                    <td className="col-sigla">{tipo.aplicavel}</td>
                    <td className="col-nome">{tipo.tipo}</td>
                    <td className="col-sigla">
                      <span className="sigla-badge">{tipo.sigla}</span>
                    </td>
                    <td className="col-prazo">{tipo.prazo}</td>
                    <td className="col-nome">{tipo.orgao_referencia}</td>
                    <td className="col-nome">{tipo.texto_padrao}</td>
                    <td className="col-status">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={tipo.ativo}
                          onChange={() => handleToggleStatus(tipo.id)}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                    <td className="col-acoes">
                      <div className="action-buttons">
                        <button 
                          className="btn-edit"
                          onClick={() => handleEdit(tipo)}
                          title="Editar"
                        >
                          <FaEdit />
                        </button>
                        <button 
                          className="btn-delete"
                          onClick={() => handleDelete(tipo.id)}
                          title="Excluir"
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            
            {filteredTiposLicenca.length === 0 && (
              <div className="empty-state">
                <div className="empty-state-icon">
                  <FaSearch size={32} />
                </div>
                <h3>Nenhum tipo de licença encontrado</h3>
                <p>Tente ajustar os filtros de pesquisa ou cadastre um novo tipo de licença.</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TiposLicenca;